module.exports = __webpack_public_path__ + "img/link.5b341832.svg";